'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { AlertTriangle, Home, RefreshCcw } from 'lucide-react';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('Page Error:', error);
  }, [error]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {/* Error Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-red-100">
            <AlertTriangle className="h-8 w-8 text-red-600" />
          </div>
          
          {/* Error Title */}
          <div className="mt-6 text-center">
            <h1 className="text-2xl font-bold text-gray-900">
              出現錯誤
            </h1>
            <p className="mt-2 text-sm text-gray-600">
              抱歉，頁面載入時發生錯誤。請稍後再試。
            </p>
          </div>
          
          {/* Error Details */}
          {error.message && (
            <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-md">
              <p className="text-sm text-red-700 font-mono">
                {error.message}
              </p>
            </div>
          )}
          
          {/* Action Buttons */}
          <div className="mt-6 flex flex-col space-y-3">
            <button
              onClick={reset}
              className="w-full inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <RefreshCcw className="mr-2 h-4 w-4" />
              重新載入
            </button>
            
            <Link
              href="/"
              className="w-full inline-flex items-center justify-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              <Home className="mr-2 h-4 w-4" />
              返回首頁
            </Link>
          </div>
          
          {/* Help Text */}
          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">
              如果問題持續發生，請{' '}
              <Link href="/contact" className="text-blue-600 hover:text-blue-500">
                聯絡客服
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}